/* eslint-disable */
import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { Autocomplete } from '@material-ui/lab';
import { Box, Button, Grid, TextField } from '@material-ui/core';
import useApp from '../../../hooks/useApp';
import filterStyles from '../../filterStyles';
import { matchOptions } from '../../../utils/filterOptions';

const DatePeriodFilter = ({ filters, setFilters }) => {
  const { partners, brokers, indicator_fei: indicators, fi_indication_stock } = useApp();
  const classes = filterStyles();

  const stockOptions = (fi_indication_stock || []).map((s) => ({ id: s.var_id, name: s.value }));

  const dateNow = DateTime.now().toISODate();
  const dateLastMonth = DateTime.now().plus({ months: -1 }).toISODate();

  const [dates, setDates] = useState({
    date_ini: filters?.date_ini || dateLastMonth,
    date_end: filters?.date_end || dateNow,
  });
  const [partner, setPartner] = useState([]);
  const [brokerId, setBrokerId] = useState([]);
  const [inviterId, setInviterId] = useState([]);
  const [stockId, setStockId] = useState([]);
  const [proposal, setProposal] = useState(filters?.proposal || '');

  // Os ids chegam pela URL antes das opções carregarem (useApp é assíncrono),
  // então reidratamos cada Autocomplete assim que a respectiva lista existir.
  useEffect(() => {
    setPartner(matchOptions(partners, filters?.partner_id));
  }, [partners]);

  useEffect(() => {
    setBrokerId(matchOptions(brokers, filters?.broker_id));
  }, [brokers]);

  useEffect(() => {
    setInviterId(matchOptions(indicators, filters?.inviter_id));
  }, [indicators]);

  useEffect(() => {
    setStockId(matchOptions(stockOptions, filters?.insurance_id));
  }, [fi_indication_stock]);

  const handleChangeDates = (e) => {
    const { name, value } = e.target;
    setDates((d) => ({ ...d, [name]: value }));
  };

  function handleSubmit(event) {
    event.preventDefault();
    setFilters({
      date_ini: dates.date_ini,
      date_end: dates.date_end,
      partner_id: partner?.map((p) => p.id) || [],
      broker_id: brokerId?.map((b) => b.id) || [],
      inviter_id: inviterId?.map((b) => b.id) || [],
      insurance_id: stockId?.map((s) => s.id) || [],
      proposal,
    });
  }

  return (
    <Box className={classes.boxFilter}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid container item xs={12} alignItems="center" spacing={2}>
            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_ini"
                value={dates.date_ini}
                onChange={handleChangeDates}
              />
            </Grid>

            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_end"
                value={dates.date_end}
                onChange={handleChangeDates}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                options={partners || []}
                value={partner}
                getOptionLabel={(option) => option?.name}
                getOptionSelected={(option, value) => option?.id === value?.id}
                onChange={(e, value) => setPartner(value)}
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Empresas" />}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                options={brokers || []}
                value={brokerId}
                getOptionLabel={(option) => option?.name}
                getOptionSelected={(option, value) => option?.id === value?.id}
                onChange={(e, value) => setBrokerId(value)}
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Corretor" />}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                options={indicators || []}
                value={inviterId}
                getOptionLabel={(option) => option?.name}
                getOptionSelected={(option, value) => option?.id === value?.id}
                onChange={(e, value) => setInviterId(value)}
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Indicador F&I" />}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                options={stockOptions}
                value={stockId}
                getOptionLabel={(option) => option?.name}
                getOptionSelected={(option, value) => option?.id === value?.id}
                onChange={(e, value) => setStockId(value)}
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Estoque" />}
              />
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} type="submit">
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default DatePeriodFilter;
